import React, { useState, useEffect } from 'react';
// 다국어
import { useTranslation } from 'react-i18next';

import { useNavigate } from 'react-router-dom';
import { styled } from '@mui/material/styles';
import Fab from '@mui/material/Fab';

const InstallButton = styled(Fab)({
    background:'linear-gradient(0deg, rgba(26, 158, 248, 0.5), rgba(26, 158, 248, 0.5)),linear-gradient(88.71deg, rgba(97, 26, 248, 0.8) 0%, rgba(109, 134, 199, 0.8) 30.71%, rgba(141, 187, 83, 0.64) 63.02%, rgba(0, 255, 117, 0.64) 100%)',
    fontSize: '1.1rem',
    fontWeight: 500,
    height: '100px',
    padding: '20px 40px',
    borderRadius: '0',

})


function RaindropStart() {
  const { t, i18n } = useTranslation(['page']);
  
    const [isAppInstalled, setIsAppInstalled] = useState(false);
    const [isChecking, setIsChecking] = useState(false);
    const [isDone, setIsDone] = useState(false);
    // const [appSchem, setAppSchem] = useState('Sugarpole.RD://open?user_token=null');
    
    let heartbeat;
    let timer;
    
    const navigate = useNavigate();
    const runRD = (appSchem) => {

        setIsChecking(true);
        clearTimers();
    
        function clearTimers() {
          clearInterval(heartbeat);
          clearTimeout(timer);
        }
    
        function intervalHeartbeat() {
          if (document.webkitHidden || document.hidden) {
            clearTimers();
            setIsAppInstalled(true);
            setIsDone(true);
          }
        }

        function notInstall() {
            if (!isAppInstalled && isChecking) {
                setIsDone(true);
                alert("레인드롭 설치페이지로 이동합니다.");
                navigate('/download', { replace: true });
            }
          }
    
        heartbeat = setInterval(intervalHeartbeat, 200);
        const deLay = 1000;
        timer = setTimeout(() => {
          setIsAppInstalled(false);
          setIsChecking(false);
        }, deLay);
        notInstall();
        
    
        window.location.href = appSchem;
      };

      const handleClick = async () => {
  
        if(sessionStorage.getItem('login_info') !== null){
          if(JSON.parse(sessionStorage.getItem('login_info')).use_license === "N/A"){
            alert("사용중인 라이센스가 없습니다!");
            navigate('/license', { replace: true });
          }else{
            const appSchem = `Sugarpole.RD://open?user_token=${JSON.parse(sessionStorage.getItem('login_info')).user_token}`;
              runRD(appSchem);
            }
        }else{
          const appSchem = `Sugarpole.RD://open?user_token=null`;
          runRD(appSchem);
        }

        // console.log("asa",JSON.parse(sessionStorage.getItem('login_info')).use_license);
            
      };
      
      return (

            <>
               <InstallButton  variant="extended" color="primary" size="medium" onClick={handleClick} style={{}}>{t('레인드롭 실행')}</InstallButton > 
            </>

      ); 
}
export default RaindropStart;